import React from "react";

import { useSelector, shallowEqual } from "react-redux";
import Header from "components/MaterialKit/Header/Header";
import gamers_world from "../../assets/img/main/gamers_world.png";
import NavbarLinks from "./NavbarLinks";

const Navbar = (props) => {
  // const dispatch = useDispatch();

  const {
    //eslint-disable-next-line
    auth: { isAuthenticated, user },
  } = useSelector((state) => {
    return {
      auth: state.auth,
    };
  }, shallowEqual);
  return (
    <div>
      <Header
        color="transparent"
        brand={<img alt="logo" src={gamers_world} width="60" height="60" />}
        fixed
        changeColorOnScroll={{
          height: 200,
          color: "black",
        }}
        rightLinks={<NavbarLinks />}
      />
    </div>
  );
};

Navbar.propTypes = {};

export default Navbar;
